<template>
    <div class="qingxu-data-board">
        <!-- 头部内容 -->
        <div class="qingxu-data-board-top">
            <div class="top-time">
                <div class="time">{{ currentTime }}</div>
                <div class="date">{{ date }}</div>
            </div>
            <div class="top-select-btn">
                <div class="left-btn">
                    <div class="btn" :class="selectType == 'all' ? 'is-select' : ''" @click="changeSelectType('all')">全部
                    </div>
                    <div class="btn" :class="selectType == 'month' ? 'is-select' : ''" @click="changeSelectType('month')">本月
                    </div>
                    <div class="btn" :class="selectType == 'semester' ? 'is-select' : ''"
                        @click="changeSelectType('semester')">本学期</div>
                    <div class="btn" :class="selectType == 'custom' ? 'is-select' : ''" @click="changeSelectType('custom')">
                        自定义</div>
                </div>
                <div v-if="selectType == 'custom'" class="custom-select">
                    <el-date-picker popper-class="qingxu-data-board-custom-data-picker" class="custom-date-picker"
                        v-model="dateValue" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeDateTime"
                        style="margin-right:15px;">
                    </el-date-picker>
                </div>
                <div class="select-right">
                    <el-select v-model="areaId" style="width:120px" popper-class="select-option"
                        :popper-append-to-body="false" @change="changeArea">
                        <el-option v-for="item in areaList" class="option-item" :key="item.value" :value="item.value"
                            :label="item.address"></el-option>
                    </el-select>
                    <el-select v-model="schoolId" style="width:120px;margin-left: 15px;"
                        popper-class="qingxu-data-board-school-select" :popper-append-to-body="true" >
                        <el-option v-for="item in schoolList" class="option-item" :key="item.schoolId"
                            :value="item.schoolId" :label="item.schoolName"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="qingxu-data-board-content">
            <!-- 左侧内容 -->
            <div class="qingxu-data-board-left">
                <resource-access-chart :regionId="regionId" :regionType="regionType" :provinceId="provinceId"
                    :districtId="districtId" :cityId="cityId" :address="areaId" :schoolId="schoolId" ></resource-access-chart>
                <resource-construction-types-chart :regionId="regionId" :regionType="regionType" :provinceId="provinceId"
                    :districtId="districtId" :cityId="cityId" :address="areaId" :schoolId="schoolId" :startTime="startTime"
                    :endTime="endTime"></resource-construction-types-chart>
                <stage-resource-distribution-chart :regionId="regionId" :provinceId="provinceId" :districtId="districtId"
                    :cityId="cityId" :address="areaId" :startTime="startTime"
                    :endTime="endTime"></stage-resource-distribution-chart>
            </div>
            <!-- 中侧内容 -->
            <div class="qingxu-data-board-center">
                <resource-display :regionId="regionId" :regionType="regionType" :provinceId="provinceId"
                    :districtId="districtId" :cityId="cityId" :address="areaId" :schoolId="schoolId" :startTime="startTime"
                    :endTime="endTime"></resource-display>
                <resource-dynamic :regionId="regionId" :provinceId="provinceId" :districtId="districtId" :cityId="cityId"
                    :address="areaId" :schoolId="schoolId" :startTime="startTime" :endTime="endTime"></resource-dynamic>
                <subject-rsources-distribution-chart :regionId="regionId" :provinceId="provinceId" :districtId="districtId"
                    :cityId="cityId" :address="areaId" :startTime="startTime"
                    :endTime="endTime"></subject-rsources-distribution-chart>
            </div>
            <!-- 右侧内容 -->
            <div class="qingxu-data-board-right">
                <top-five-active-schools :regionId="regionId" :regionType="regionType" :provinceId="provinceId"
                    :districtId="districtId" :cityId="cityId" :address="areaId" :startTime="startTime"
                    :endTime="endTime"></top-five-active-schools>
                    <top-five-active-resource :regionId="regionId"></top-five-active-resource>
            </div>
        </div>

    </div>
</template>
<script>
import ResourceAccessChart from "./modules/ResourceAccessChart.vue"
import ResourceConstructionTypesChart from "./modules/ResourceConstructionTypesChart.vue"
import StageResourceDistributionChart from "./modules/StageResourceDistributionChart.vue"
import ResourceDisplay from "./modules/ResourceDisplay.vue"
import ResourceDynamic from "./modules/ResourceDynamic.vue"
import SubjectRsourcesDistributionChart from "./modules/SubjectRsourcesDistributionChart.vue"
import TopFiveActiveSchools from "./modules/TopFiveActiveSchools.vue"
import TopFiveActiveResource from "./modules/TopFiveActiveResource.vue"
import { getNextRegionSchoolInfomation, getDistrictSchoolList, getPlatFormInfoByPlatformDomainAPI, } from "@/service/api"
export default {
    name: 'qingxu-data-board',
    components: {
        ResourceAccessChart,
        ResourceConstructionTypesChart,
        StageResourceDistributionChart,
        ResourceDisplay,
        ResourceDynamic,
        SubjectRsourcesDistributionChart,
        TopFiveActiveSchools,
        TopFiveActiveResource
    },
    data() {
        return {
            dateValue: '',
            timeInterval: null,
            //导航栏时间
            currentTime: "",
            //导航栏日期
            date: '',
            selectType: "all",
            areaId: "",
            //地区列表
            areaList: [
                {
                    address: "全部区域",
                    value: ""
                }
            ],
            schoolId: "",
            schoolList: [
                {
                    schoolId: "",
                    schoolName: "全部学校"
                }
            ],
            cityId: "140100",
            districtId: "140121",
            provinceId: "140000",
            regionId: "c5c29d5be731480c98abbfcc9b0fa43b",
            //平台类型
            regionType: "3",
            //平台名称
            regionName: "清徐县教育云平台",
            startTime: "",
            endTime: "",
        }
    },
    methods: {
        /**
         * @name 切换区域
         */
        changeArea() {
            this.schoolId = ''
            this.schoolList = [];
            this.getSchoolList();
        },
        /**
         * @name 切换筛选类型
         */
        changeSelectType(type) {
            if (this.selectType == type) {
                return
            }
            this.selectType = type;
            if (type == 'all') {
                this.startTime = "";
                this.endTime = ""
            } else if (type == 'month') {
                this.startTime = this.$utils.getMonthStartDate();
                this.endTime = this.$utils.getMonthEndDate();
            } else if (type == 'semester') {
                //判断当前日期是在学年的前半段还是后半段
                let year = new Date().getFullYear();
                //当前时间大于学年开始时间，则处于学年的后半段
                if (new Date().getTime() < new Date(`${year}-08-10 00:00:00`).getTime()) {
                    this.startTime = `${year}-02-01`;
                    this.endTime = `${year}-08-09`
                } else {
                    this.startTime = `${year}-08-10`;
                    this.endTime = `${year + 1}-01-31`
                }
            }
        },
        /**
         * @name 切换时间
         */
        changeDateTime(date) {
            if (date) {
                this.startTime = date[0];
                this.endTime = date[1]
            } else {
                this.startTime = '';
                this.endTime = '';
            }
        },
        /**
         * @name 获取时间
         */
        getTime() {
            const now = new Date();
            const year = now.getFullYear();
            let month = now.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            let day = now.getDate();
            day = day < 10 ? '0' + day : day;
            let hour = now.getHours();
            hour = hour < 10 ? '0' + hour : hour;
            let minute = now.getMinutes();
            minute = minute < 10 ? '0' + minute : minute;
            let second = now.getSeconds();
            second = second < 10 ? '0' + second : second;
            this.date = `${year}年${month}月${day}日`
            this.currentTime = `${hour}:${minute}:${second}`
        },
        /**
         * @name 获取省市区下的镇
         */
        getTownlet() {
            let params = {
                provinceCode: this.provinceId,
                cityCode: this.cityId,
                districtCode: this.districtId,
                isTowns: 1
            }
            getNextRegionSchoolInfomation(params).then((res) => {
                this.areaList = res.map((item) => {
                    return {
                        ...item,
                        value: item.address
                    }
                })
                this.areaList.unshift({
                    value: "",
                    address: '全部区域'
                })
            }).catch((err) => {
            })
        },
        /**
         * @name 获取学校列表
         */
        getSchoolList() {
            let params = {
                province: this.provinceId,
                city: this.cityId,
                districtId: this.districtId,
                page: 1,
                limit: 100,
                keyWord: "",
                isTowns: 1,
                address: this.areaId
            }
            getDistrictSchoolList(params).then((res) => {
                this.schoolList = res.classCountList.map((item) => {
                    return {
                        ...item,
                        schoolId: item.id,
                        schoolName: item.school_name
                    }
                })
                this.schoolList.unshift({
                    schoolId: '',
                    schoolName: '全部学校'
                })
            }).catch((err) => {

            })
        },
        // /**
        //  * @name 根据域名获取区域信息
        //  */
        // getRegionByDomain() {
        //     let params = {
        //         platformDomain: "www.qingxuzhjy.cn"
        //     }
        //     getPlatFormInfoByPlatformDomainAPI(params).then((res) => {
        //         this.regionName = res.platformName;
        //         this.regionId = res.id;
        //         this.regionType = res.regionPlatformType;
        //         this.provinceId = res.region[0].provinceId;
        //         this.cityId = res.region[0].cityId;
        //         this.districtId = res.region[0].districtId;
        //     }).catch((err) => {
        //     })
        // },

    },
    mounted() {
        //刷新当前时间
        this.timeInterval = setInterval(() => {
            this.getTime()
        }, 1000);
        //获取省市区下的镇
        this.getTownlet();
        //获取省市区下的学校
        this.getSchoolList();
        //通过域名获取区域
        // this.getRegionByDomain();
    }
}
</script>
<style lang="scss" scoped>
.qingxu-data-board {
    background: url("~@/assets/images/qingxudataboard/background.png") no-repeat;
    background-size: 100% 100%;

    .qingxu-data-board-top {
        height: 140px;
        width: 100%;
        background: url("~@/assets/images/qingxudataboard/head_bg.png") no-repeat;
        background-size: 100% auto;
        position: relative;

        .top-time {
            position: absolute;
            top: 5px;
            right: 40px;
            color: #fff;
            display: flex;
            align-items: center;
            letter-spacing: -0.4px;

            .time {
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #C1ECFF;
            }

            .date {
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7B9DAD;
                margin-left: 11px;
            }
        }

        .top-select-btn {
            position: absolute;
            bottom: 10px;
            right: 30px;
            display: flex;
            align-items: center;

            .left-btn {
                width: 280px;
                height: 36px;
                background: rgba(31, 51, 141, 0.57);
                border-radius: 4px;
                display: flex;
                align-items: center;
                margin-right: 20px;
                padding: 2px;

                .btn {
                    padding: 9px 16px;
                    margin-right: 5px;
                    background: transparent;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #C1ECFF;
                    white-space: nowrap;
                    cursor: pointer;
                }

                .is-select {
                    background: linear-gradient(0deg, #177BC1 0%, #20B8CE 100%);
                    border-radius: 4px;
                }
            }
        }
    }

    .qingxu-data-board-content {
        width: 100%;
        padding: 0 20px 20px;
        display: flex;

        .qingxu-data-board-left {
            width: calc(25% - 15px);
            margin-right: 20px;
        }

        .qingxu-data-board-center {
            width: calc(50% - 15px);
            margin-right: 25px;
        }

        .qingxu-data-board-right {
            width: calc(25% - 15px);
            display: flex;
            flex-wrap: wrap;
        }
    }
}
</style>
<style lang="scss">
.qingxu-data-board {
    .qingxu-data-board-top {
        .top-select-btn {
            .select-right {
                .el-select {
                    .el-input {
                        .el-input__inner {
                            background-color: rgba(31, 51, 141, 0.57);
                            border-color: rgba(31, 51, 141, 0.57);
                            color: #C1ECFF;
                        }

                        .el-input__suffix {
                            .el-input__suffix-inner {
                                i {
                                    color: #C1ECFF
                                }
                            }
                        }
                    }
                }

                .select-option {
                    background-color: #1F338D;
                    border-color: #1F338D;

                    .popper__arrow {
                        display: none;
                    }

                    .popper__arrow {
                        border-color: #1F338D;
                    }

                    .option-item {
                        background-color: #1F338D;
                        color: #fff;
                    }

                    .selected {
                        color: #20B8CE;
                    }
                }
            }

            .custom-select {
                .custom-date-picker {
                    width: 270px;
                    background-color: #1F338D;
                    border-color: #1F338D;
                    color: #C1ECFF;

                    .el-range-input {
                        background-color: #1F338D;
                        border-color: #1F338D;
                        color: #C1ECFF;
                    }

                    .el-range-separator {
                        padding: 0;
                        color: #C1ECFF;
                    }
                }
            }
        }
    }
}

.qingxu-data-board-school-select {
    background-color: #1F338D;
    border-color: #1F338D;

    .popper__arrow {
        display: none;
    }

    .popper__arrow {
        border-color: #1F338D;
    }

    .option-item {
        background-color: #1F338D;
        color: #fff;
    }

    .selected {
        color: #20B8CE;
    }
}

.qingxu-data-board-custom-data-picker {
    background: #1F338D;
    border-color: #1F338D;

    .el-date-range-picker__header {
        color: #fff;

        .el-picker-panel__icon-btn {
            color: #fff;
        }
    }

    .el-date-table {
        color: #fff;

        th {
            color: #fff
        }
    }

    .el-date-table td.in-range div,
    .el-date-table td.in-range div:hover,
    .el-date-table.is-week-mode .el-date-table__row.current div,
    .el-date-table.is-week-mode .el-date-table__row:hover div {
        background-color: #20B8CE;
    }

    .popper__arrow {
        display: none;
    }
}
</style>